var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section"}},[_c('tb',{attrs:{"t-btxt1":_vm.p11ssubtitlep4,"t-btxt2":_vm.p11ssubtitlep5,"t-button1":_vm.p11ssubtitlep6,"t-button2":_vm.p11ssubtitlep7,"t-burl":_vm.p11surl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }